export default {
      id: "i-arrow-right2-usage",
      viewBox: "0 0 10 7",
      url: __webpack_public_path__ + "img/sprite.svg#i-arrow-right2",
      toString: function () {
        return this.url;
      }
    }